import type { SessionState } from './_state.type';

/** Session State. */
export const sessionState: SessionState = {
  session: {},
};
